import { useSearchParams } from "react-router-dom";
import { GlobalConfiguration } from "./configurationProvider";

const useCustomSearchParams = (props) => {
  const [searchParam, setSearchParam] = useSearchParams(props);

  const handleSearchParams = (key, value) => {
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(currentParams);

    const hasValue =
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !(
        Array.isArray(value) &&
        value.length === GlobalConfiguration.lengthCheckZero
      );

    if (hasValue) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }

    if (key !== "pageno") {
      newParams.set("pageno", GlobalConfiguration.lengthCheckOne);
    }

    setSearchParam(newParams, { replace: true });
  };

  const handleClearSearchParam = () => {
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(currentParams);
    for (const [key] of newParams.entries()) {
      newParams.delete(key);
    }
    setSearchParam(newParams, { replace: true });
  };

  return { handleSearchParams, handleClearSearchParam, searchParam };
};

export default useCustomSearchParams;
